<template>
        <div class="login-container qb-shadow-1" :class="background">
            <div class="login-wrap">
                <vue-element-loading :active="show" spinner="bar-fade-scale"/>
                <form v-if="!showPolitica" v-on:submit.prevent="onSubmit" class="login-form">
                    <img src="../../assets/logo-floresta-semborda.png" alt="" class="img-logo-login">
                    <span class="login-form-title">Entrar</span>
                    <div class="input-container qb-margin-bottom">
                        <input type="text" name="login" v-model="user.login" placeholder="Digite seu usuário" autocomplete="off" autofocus/>
                    </div>
                    <zoom-x-transition group :duration="300">
                        <div key="1" class="input-container qb-margin-bottom" v-if="password">
                            <input type="password" name="password" v-model="user.password" placeholder="Digite sua senha" autocomplete="off" v-focus/>
                        </div>

                        <div key="2" class="input-container" v-if="newPassword">
                            <input type="password" name="password" v-model="user.confirmPassword" placeholder="Confirme sua senha" autocomplete="off"/>
                        </div>
                   </zoom-x-transition>
                                   
                    <div class="input-container qb-margin-bottom" v-if="vendedor==true">
                        <vue-element-loading :active="!this.optionsPronto" spinner="bar-fade-scale"/>

                        <v-select v-if="options.length > 0" v-model="selected" :options="options" :value="$store.myValue" @input="SetCliente">
                        </v-select>
                        <span v-if="vendedor && options.length <= 0" >Você não possui clientes vinculados a você.</span>

                        <v-select v-model="selected2" v-if=" vendedor && options2.length > 0" :options="options2" :value="$store.myValue" @input="SetPagamento" style="margin-top:10px;">
                        </v-select>
                    </div>

                    <div class="form-action">
                        <zoom-x-transition group :duration="300">
                            <button key="1" class="btn qb-color-2 btn-full qb-margin-top" v-if="!newPassword && !password" @click="next">Próximo</button>
                            
                            <button key="2" v-if="newPassword" @click="changePassword" class="btn qb-color-2 btn-full qb-margin-top">Cadastrar</button>
                            
                            <button key="3" v-if="password && !newPassword" @click="signin" class="btn qb-color-2 btn-full qb-margin-top">Login</button>
                        </zoom-x-transition>
                    </div>
                </form>
                <div class="div-politica" v-if="showPolitica">
                    <h3>Termos e Condições Comerciais</h3>
                    <label>
                        <input type="checkbox" class="check-termo" v-model="termo">
                        Declaro ter lido e concordo com os <a target="_blank" href="https://ecommerce.florestaimport.com.br/Termos_e_Condicoes_Gerais_de_Fornecimento_de_Produtos_V2021.pdf">Termos e Condições Comerciais</a>
                    </label>
                    <button key="5" class="btn qb-color-2 btn-full qb-margin-top" @click="aceite">Continuar</button>
                    <div class="sair-termo">
                        <a @click="sair_termo">Sair</a>
                    </div>
                </div>
                <!-- <div style="display:flex; justify-content: center;" class="qb-margin-bottom qb-margin-top">
                    <div class="bg-gradient-1 tema" @click="mudarBackground('bg-gradient-1', $event)">
                    </div>
                </div> -->
            </div>
        </div>
</template>

<script>
import {userKey, baseApiUrl} from '@/global';
import axios from "axios";
import VueElementLoading from 'vue-element-loading';
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';
import { ZoomXTransition } from 'vue2-transitions';


export default {
    components:{
         VueElementLoading,
         ZoomXTransition,
        vSelect
    },
    name: 'login',
    data(){
        return{
            user: {},
            newPassword: false,
            vendedor: false,
            optionsPronto: false,
            vendedorID: 0,
            nomeCliente:'',
            cliente: 0,
            selected: {label:'Selecione um Cliente', id:0},
            options: [],
            usuarios:[],
            pagamento: 0,
            selected2: {label:'Selecione uma Forma de Pagamento', id:0},
            options2: [],
            pagamentos:[],
            password: false,
            background:'bg-gradient-1',
            show: false,
            showPolitica: false,
            termo: false,
            bkpAceite: null,
        }
    },
    methods: {
      mudarBackground(param, event){
          if(this.background != param){
              var div = document.querySelectorAll(`.${this.background}`);
              div[1].classList.remove("active");
          }
          event.target.className += ' active';
          this.background=param;
      },

      next(){
          this.show=true;
            axios.post(`${ baseApiUrl }/login/new`, this.user)
            .then(res => {
               if(res.data.valid){
                   this.$awn.info(res.data.message, {labels: {info: res.data.title }});
                   this.password = true;
                   if(res.data.newUser){
                       this.newPassword = true;
                   }
               }else{
                    this.$awn.alert(res.data.message, {labels: {alert: 'ERRO' }});
               }
               this.show=false
            }).catch(err => {
                this.$awn.alert('Problema ao autenticar, tente novamente', err, {labels: {alert: 'Erro' }});
                this.show=false
            })
      },

      changePassword(){
        this.show=true;
          axios.post(`${ baseApiUrl }/login/password`, this.user)
            .then(res => {
                    if(res.data.valid){
                        this.$awn.success(res.data.message, {labels: {alert: res.data.title }});
                        this.password = true;
                        this.newPassword = false;
                    }else{
                        this.$awn.alert(res.data.message, {labels: {alert: res.data.title }});
                    }
                    this.show=false
            }).catch(err => {
                this.$awn.alert('Problema ao autenticar, tente novamente', err, {labels: {alert: 'Erro' }});
                this.show=false
            })
      },
      signin(){
        this.show=true;
          axios.post(`${baseApiUrl}/login`, this.user)
         .then(res =>{
             if(res.data.autenticated){
              
                if(this.vendedor==false && res.data['tipoAcesso'] != "V")
                {
                    this.pagamento = 404;
                    this.cliente = 404;
                }
                if(res.data['tipoAcesso'] == "V" && this.pagamento == 0 || this.cliente == 0){
                    this.vendedor = true;
                    this.vendedorID = res.data['vendedor'];
                    this.carregaClientes();  
                    this.carregaPagamentos();              
                }else{
                    if(res.data.politica == 'N'){
                        this.bkpAceite = res.data;
                        this.showPolitica = true;
                    }else if(res.data.politica == 'S'){
                        this.$store.commit('setUser', res.data);  
                        localStorage.setItem(userKey, JSON.stringify(res.data));
                        this.$router.push({ path: '/' }); 
                    }
                }
             }else{
                this.$awn.alert(res.data.message, {labels: {alert: res.data.title }});
             }
               this.show=false
         }).catch(err => {
                this.$awn.alert('Problema ao autenticar, tente novamente', err, {labels: {alert: 'Erro' }});
                this.show=false
            })
      },
      sair_termo(){
        window.location.reload();
      },
      aceite(){   
          this.show = true;
          if(this.termo){     
            axios.post(`${baseApiUrl}/login/aceite`, {...this.bkpAceite, ...this.user}, {
                headers: {
                    Authorization: 'bearer ' + this.bkpAceite.accessToken,
                }})
            .then(res => {
                if(res.data){
                    this.$store.commit('setUser', this.bkpAceite);
                        localStorage.setItem(userKey, JSON.stringify(this.bkpAceite));
                        this.$router.push({ path: '/' });
                }else{
                        this.$awn.alert('Problema ao autenticar, tente novamente', "", {labels: {alert: 'Erro' }});
                        this.show=false
                }              
            })
            .catch(err => {
                this.$awn.alert('Problema ao autenticar, tente novamente', err, {labels: {alert: 'Erro' }});
                this.show=false
            })
          }else{
              this.$awn.alert('Você deve aceitar os Termos e Condições Comerciais para continuar', '', {labels: {alert: 'Atenção' }});
                this.show=false
          }
      },
        carregaClientes(){
            axios.get(`${baseApiUrl}/login/clientes/?userId=${this.vendedorID}`)
            .then(res => {
                this.usuarios = res.data;
                this.usuarios.forEach(element => {
                    this.options.push({'label': element.id + ' ' + element.description + ' ' + element.doc , 'id': element.id, 'nome': element.description});
                });
                this.optionsPronto = true;
            });            
        },  
        carregaPagamentos(){
            axios.get(`${baseApiUrl}/payments/pagamentos/`)
            .then(res => {
                this.pagamentos = res.data;
                this.pagamentos.forEach(element => {
                    this.options2.push({'label': element.description , 'id': element.id, 'avista': element.inCash });
                });
            });            
        },
        SetCliente (cliente)
        {
            const id =(cliente == null ? 0 : cliente.id);
            this.cliente = id;
            localStorage.setItem('cliente_vinculado', JSON.stringify({"id":id, "nome":cliente.nome}));
        },
        SetPagamento (pagamento)
        {
            const id =(pagamento == null ? '0' : pagamento.id);
            this.pagamento = id;
            localStorage.setItem('forma_pagamento', JSON.stringify({"id":id, "label":pagamento.label, "avista":pagamento.avista}));
        },
        onSubmit(){
            
        }  
    },
    directives: {
    focus: {
        inserted: function (el) {
        el.focus()
        }
    }
    },
    mounted(){
        var div = document.querySelectorAll(`.${this.background}`);
        div[1].classList.add("active");
    }
}
</script>

<style scoped>

.check-termo {
    width: 25px;
    height: 25px;
    margin-right: 10px;
    margin-top: 5px;
    float: left;
}

.div-politica {
    min-height: 200px;
    padding: 32px;
}

.div-politica a {
    text-decoration: underline;
}
.sair-termo {
    text-align: center;
    margin-top: 15px;
}
.sair-termo a {
    cursor: pointer;
}
.active{
    border: 2px solid #ffc300;
}
.tema{
    width: 40px;
    height: 40px;
    margin-right: 4px;
}
.tema:nth-child(7n){
    margin-right: 0px;
}
/* bg-color gradient */
.bg-gradient-1{
    background: #d3dbd3;
    background: -webkit-linear-gradient(to right, #d3dbd3, #006f3a);
    background: linear-gradient(to right, #d3dbd3, #006f3a);
}


/* bg-imagem */


.login-container{
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    align-items: center;
    padding: 16px;
    box-sizing: border-box;
    flex-direction: column;
}
.login-wrap{
    width: 500px;
    background: #fff;
    border:solid  #006f3a;
    border-radius: 10px;
    overflow: hidden;
}
.login-form{
    width: 100%;
    box-sizing: border-box;
    padding: 32px;
    text-align: center;
}
.login-form-title{
    display: block;
    font-size: 40px;
    color: #333;
    line-height: 1.2;
    text-align: center;
    padding-bottom: 32px;
}

.img-logo-login{
    width: 90%;
}

input{
    width: 100%;
    border: none;
    border-bottom-color: currentcolor;
    border-bottom-style: none;
    border-bottom-width: medium;
    border-bottom: 1px solid lightgray;
    height: 55px;
    padding-left: 8px;
    box-sizing: border-box;
}

input:focus{
    border-color: #d3dbd3;
     -webkit-transition: all 0.8s ease;
    transition: all 0.8s ease;
}

@media screen and (max-width: 520px) {
    .login-wrap{
        width: 95%;
        min-width: 315px;
    }
}

</style>
